import { CONSENT_CHANGED_EVENT, writeConsent, type Consent } from "@/lib/analytics/consent";

/**
 * Persist a consent choice and reflect it in PostHog: granting opts capturing
 * in (enabling cookie persistence) and records the current page; declining
 * opts out. Dispatches {@link CONSENT_CHANGED_EVENT} so the banner re-reads.
 * Client-only — imported solely by the analytics client components.
 */
export function applyConsent(value: Consent) {
  writeConsent(value);
  // Lazy import keeps posthog-js out of the first-load bundle; resolves to the
  // same singleton Analytics init'd. Fire-and-forget — the consent write +
  // event dispatch below are what the UI reacts to.
  void import("posthog-js").then(({ default: posthog }) => {
    if (value === "granted") {
      posthog.opt_in_capturing();
      posthog.capture("$pageview");
    } else {
      posthog.opt_out_capturing();
    }
  });
  window.dispatchEvent(new Event(CONSENT_CHANGED_EVENT));
}
